import React from 'react';
import { Select } from 'antd';
import { AcvtSupportedLanguages } from '../../../../types/acvt';
import { useT } from '../../../preview';
import style from './style.module.scss';

const { Option } = Select;

export const AcvtCouponsPage = (props: {
    /**
     * Kept for backward compatibility — strings come from `useT()`.
     */
    language?: AcvtSupportedLanguages;
    cards: React.ReactNode;
    offersList?: (string | undefined | null)[];
    categoriesList?: (string | undefined | null)[];
    selectedOffer: string | undefined;
    selectedCategory: string | undefined;
    changeOffers: (selection: string) => void;
    changeCategories: (selection: string) => void;
}) => {
    const t = useT();

    return (
        <div className={style.page_container}>
            <div className={style.selector_container}>
                <Select
                    placeholder={t.promotions.offersPlaceholder}
                    allowClear
                    style={{ width: 160, margin: 5 }}
                    onChange={props.changeOffers}
                    defaultValue={props.selectedOffer}
                >
                    {props.offersList?.map((offer) => (
                        <Option key={`${offer}`} value={`${offer}`}>
                            {offer}
                        </Option>
                    ))}
                </Select>
                <Select
                    placeholder={t.promotions.categoriesPlaceholder}
                    allowClear
                    style={{ width: 160, margin: 5 }}
                    onChange={props.changeCategories}
                    defaultValue={props.selectedCategory}
                >
                    {props.categoriesList?.map((category) => (
                        <Option key={`${category}`} value={`${category}`}>
                            {category}
                        </Option>
                    ))}
                </Select>
            </div>
            <div className={style.coupons_content}>
                <h3 className={style.header}>{t.promotions.couponsHeading}</h3>
                {props.cards}
            </div>
        </div>
    );
};
